import type { JSX } from "react";
import { Sun, Moon, Mail } from "lucide-react";
import { FaGithub } from "react-icons/fa";
import { useSceneStore } from "@/state/useSceneStore";

export const Header = (): JSX.Element => {
  const theme = useSceneStore((s) => s.theme);
  const setTheme = useSceneStore((s) => s.setTheme);
  const setActiveSection = useSceneStore((s) => s.setActiveSection);
  return (
    <header className="absolute inset-x-0 top-0 z-20 flex items-center justify-between px-4 py-3 font-mono text-xs uppercase tracking-wider">
      <a
        href="/"
        aria-label="Home"
        onClick={(e) => {
          e.preventDefault();
          setActiveSection(null);
        }}
        className="text-ink0 hover:text-phosphor"
      >
        ADAM@KOTLORZ
      </a>
      <nav className="flex items-center gap-3">
        <button
          type="button"
          onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
          aria-label="Toggle theme"
          className="text-ink0 hover:text-phosphor"
        >
          {theme === "dark" ? <Sun size={16} /> : <Moon size={16} />}
        </button>
        <a
          href="https://github.com/adkotlorz"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-1 text-ink0 hover:text-phosphor"
        >
          <FaGithub size={16} /> github
        </a>
        <a
          href="mailto:ad.kotlorz@gmail.com"
          className="flex items-center gap-1 text-ink0 hover:text-phosphor"
        >
          <Mail size={16} /> hire me
        </a>
      </nav>
    </header>
  );
};
